import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Link as NextLink } from '../../../routes';

import { Root, Item, Link } from './styles';
import Icon from '../Icon';

class Badge extends PureComponent {
  renderItem = ({ href, label }, index) => {
    const isCurrent = index === this.props.items.length - 1;

    return (
      <Item key={index} current={isCurrent}>
        {isCurrent ? (
          label
        ) : (
          <NextLink route={href} passHref>
            <Link>
              {label}
              <Icon name="chevron-right" />
            </Link>
          </NextLink>
        )}
      </Item>
    );
  };

  renderItems = () => {
    return this.props.items.map(this.renderItem);
  };

  render() {
    return <Root>{this.renderItems()}</Root>;
  }
}

Badge.propTypes = {
  items: PropTypes.array.isRequired
};

export default Badge;
